import * as yup from 'yup';

import { isPasswordValid } from '@identity/domain/value-objects';

/** The data of the in-session change: the secret being replaced, and the one replacing it. */
export type ChangePasswordFormValues = {
  currentPassword: string;
  password: string;
};

/** i18n keys the resolver writes in the field errors and the component translates. */
export const CHANGE_PASSWORD_VALIDATION_KEYS = {
  currentRequired: 'validation.currentPassword.required',
  required: 'validation.password.required',
  policy: 'validation.password.policy',
} as const;

/**
 * Validation schema of the password change.
 *
 * The policy is checked on the new password only, with the same function the checklist uses. The one
 * being replaced has no rule beyond existing: it is a secret to compare, not one to create, and it
 * may well predate the policy in force — which is often exactly why it is being changed.
 */
export const createChangePasswordFormSchema = () =>
  yup.object({
    currentPassword: yup.string().required(CHANGE_PASSWORD_VALIDATION_KEYS.currentRequired),
    password: yup
      .string()
      .required(CHANGE_PASSWORD_VALIDATION_KEYS.required)
      .test('password-policy', CHANGE_PASSWORD_VALIDATION_KEYS.policy, (value) => isPasswordValid(value ?? '')),
  });
